import * as D from "schemawax";
import { PowerExchangesEnum } from "@flexidao/dto";

export const powerExchangeDecoder: D.Decoder<PowerExchangesEnum> = D.literalUnion(
    ...Object.values(PowerExchangesEnum),
);
